import React from 'react';

interface Props {
  className?: string;
  color?: string;
}

export function IconPhoneSolid(props: Props) {
  const { className = '', color = '#1FAB71' } = props;

  return (
    <svg
      className={className}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.25C12.5858 2.25 12.25 2.58579 12.25 3C12.25 3.41421 12.5858 3.75 13 3.75C13.9521 3.75 14.8948 3.93753 15.7745 4.30187C16.6541 4.66622 17.4533 5.20025 18.1265 5.87348C18.7997 6.5467 19.3338 7.34593 19.6981 8.22554C20.0625 9.10516 20.25 10.0479 20.25 11C20.25 11.4142 20.5858 11.75 21 11.75C21.4142 11.75 21.75 11.4142 21.75 11C21.75 9.85093 21.5237 8.71312 21.0839 7.65152C20.6442 6.58992 19.9997 5.62533 19.1872 4.81282C18.3747 4.0003 17.4101 3.35578 16.3485 2.91605C15.2869 2.47633 14.1491 2.25 13 2.25ZM21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19ZM12.25 7C12.25 6.58579 12.5858 6.25 13 6.25C13.6238 6.25 14.2414 6.37286 14.8177 6.61157C15.394 6.85028 15.9177 7.20016 16.3588 7.64124C16.7998 8.08232 17.1497 8.60596 17.3884 9.18225C17.6271 9.75855 17.75 10.3762 17.75 11C17.75 11.4142 17.4142 11.75 17 11.75C16.5858 11.75 16.25 11.4142 16.25 11C16.25 10.5732 16.1659 10.1506 16.0026 9.75628C15.8393 9.36197 15.5999 9.00369 15.2981 8.7019C14.9963 8.40011 14.638 8.16072 14.2437 7.99739C13.8494 7.83406 13.4268 7.75 13 7.75C12.5858 7.75 12.25 7.41421 12.25 7Z"
        fill={color}
      />
    </svg>
  );
}
